"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignPublishUtils = void 0;
const casa_rules_v2_1 = require("./casa-rules-v2");
const _ = __importStar(require("lodash"));
const uuid = require('uuid/v4');
class CampaignPublishUtils {
    constructor() {
        this.campaignPublishEndPoint = '/campaigns/publish';
        this.jobScheduleEndPoint = '/job/schedule';
        this.operationTypes = {
            number: 'numeric',
            string: 'text',
            date: 'date'
        };
        this.converters = {
            "FieldCondition": (c) => this.convertFieldCondition(c),
            "JoinCondition": (c) => this.convertJoinCondition(c),
            "ListCondition": (c) => this.convertListCondition(c),
            "SectionCondition": (c) => this.convertSectionCondition(c)
        };
    }
    toPublishObject(campaign) {
        let receiver = _.reduce(campaign.recipients, (acc, recipient) => {
            let recipientType = recipient.className.replace('Recipient', '').toLowerCase();
            let recipientObject = _.toPlainObject(recipient);
            delete recipientObject['className'];
            acc[recipientType] = recipientObject;
            return acc;
        }, {});
        let joinCondition = campaign.rule.joinCondition;
        let campaignPublishObj = Object.assign(Object.assign({ id: campaign.id, ruleId: campaign.id, name: campaign.name, isCampaignGrouper: campaign.isCampaignGrouper, groupCampaignId: campaign.groupCampaignId, priority: campaign.priority, eventType: typeof (campaign.rule.triggers) === 'string' ? campaign.rule.triggers : _.head(campaign.rule.triggers), hasDirectLink: campaign.hasDirectLink, linkType: campaign.linkType, campaignFormName: campaign.campaignFormName, directLink: campaign.directLink, directLinkWithoutShorten: campaign.directLinkWithoutShorten, dynamicAttachment: campaign.dynamicAttachment || null, startDate: _.get(campaign, 'startDate', null), endDate: _.get(campaign, 'endDate', null), createdDate: new Date().toISOString(), isEnabled: campaign.isEnabled, topic: _.head(campaign.topics), contentMode: campaign.contentMode, tenant: campaign.tenant, promotionUrls: campaign.promotionUrls, businessUnit: campaign.businessUnit, tenantBrandBusinessId: campaign.tenantBrandBusinessId, tenantId: campaign.tenantId, templateData: campaign.templateData, notification: {
                id: `${campaign.id};${campaign.name}`,
                isAutoSelect: campaign.isAutoSelect,
                receiver
            }, on: this.convert(joinCondition), trackConversionUntil: campaign.trackConversionUntil, conversionMode: _.get(campaign, 'conversionMode', 'fixed'), muffler: _.get(campaign, 'muffler', null), currentCycle: campaign.currentCycle, currentCycleStartDate: campaign.currentCycleStartDate, trackConversion: campaign.trackConversion }, this.getExtraData(campaign)), { variants: campaign.variants.map((v) => (Object.assign(Object.assign({}, v), { id: v.id || uuid() }))), successMetricData: _.get(campaign, 'successMetricData', ""), journeyId: _.get(campaign, 'journeyId', null), nodeId: _.get(campaign, 'nodeId', null), actions: _.get(campaign, 'actions', []), nodeWaitTimes: _.get(campaign, 'nodeWaitTimes', null), isRealtimeJourney: _.get(campaign, 'isRealtimeJourney', null), links: campaign.links, variantId: _.get(campaign, 'variantId', null) });
        if (campaign.rule.isBatch) {
            return _.extend(campaignPublishObj, this.getBatchRuleFields(campaign));
        }
        else {
            return campaignPublishObj;
        }
    }
    // private getStartOfDay() {
    //   var start = new Date();
    //   start.setHours(0,0,0,0);
    //   return start.toISOString();
    // }
    // private getEndOfDay() {
    //   var start = new Date();
    //   start.setHours(23,59,59,0);
    //   return start.toISOString();
    // }
    getBatchRuleFields(campaign) {
        return {
            isBatch: true,
            eventType: 'batch',
            source: {
                resource: campaign.rule.batchRulesSource,
                query: '{}'
            }
        };
    }
    getExtraData(campaign) {
        if (_.some(campaign.extraData.offers) || _.some(campaign.extraData.vouchagramCoupons) ||
            _.some(campaign.extraData.offerTags)) {
            return {
                extraData: {
                    offers: _.map(campaign.extraData.offers, (o) => ({
                        code: o.code
                    })),
                    vouchagramCoupons: _.map(campaign.extraData.vouchagramCoupons, (v) => ({
                        productGuId: v.productGuid
                    })),
                    offerTags: _.map(campaign.extraData.offerTags, (v) => ({
                        name: v.name, id: v.id
                    }))
                }
            };
        }
        if (!_.isEmpty(campaign.extraData.loyalty)) {
            return {
                extraData: {
                    loyalty: campaign.extraData.loyalty
                }
            };
        }
        return {};
    }
    convert(condition) {
        let converter = this.converters[condition.className];
        return converter(condition);
    }
    convertFieldCondition(fieldCondition) {
        const operator = _.get(fieldCondition, 'operator', (0, casa_rules_v2_1.getOperator)("string", "matches"));
        const operatorType = _.get(operator, "operatorType", "string");
        return {
            className: fieldCondition.className,
            negate: fieldCondition.negate,
            operationType: this.operationTypes[operatorType] || operatorType,
            fieldAccessor: fieldCondition.fieldAccessor,
            value: fieldCondition.value,
            operator: operator.name
        };
    }
    convertJoinCondition(joinCondition) {
        return {
            className: joinCondition.className,
            negate: joinCondition.negate,
            joinType: joinCondition.joinType === casa_rules_v2_1.JoinType.AND ? 'all' : 'any',
            conditions: _.chain(joinCondition.conditions).map((c) => this.convert(c)).flatten().value()
        };
    }
    convertListCondition(listCondition) {
        return {
            className: listCondition.className,
            negate: listCondition.negate,
            listAccessor: listCondition.listAccessor,
            countType: casa_rules_v2_1.ListCountType[listCondition.countType],
            count: listCondition.count,
            countField: listCondition.countField || "",
            condition: this.convert(listCondition.condition)
        };
    }
    convertSectionCondition(sectionCondition) {
        return {
            className: sectionCondition.className,
            negate: sectionCondition.negate,
            listAccessor: sectionCondition.listAccessor,
            condition: this.convert(sectionCondition.condition)
        };
    }
}
exports.CampaignPublishUtils = CampaignPublishUtils;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/publish-format.js
// module id = 1258
// module chunks = 0